import React, { Component } from "react";
import { Col, Row, Grid } from "react-bootstrap";
import classnames from "classnames";
import styles from "./Profile.scss";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";

class Profile extends Component {
  render() {
    const { companyData } = this.props;

    return (
      <section className={styles.profileContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <Grid className={styles.maxWidth}>
            <Row>
              <Col>
                <h1>{companyData && companyData.name}</h1>
              </Col>
            </Row>
            <Row>
              <div className={styles.dividerDouble} />
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Summary</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <p>{companyData && companyData.summary}</p>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Company Vitals</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                {companyData && (
                  <div>
                    <Row className={styles.box}>
                      <Col xs={12} sm={4} md={3}>
                        <p>
                          <span className={styles.companyVitalsTitle}>
                            Industry
                          </span>
                        </p>
                      </Col>
                      <Col xs={12} sm={8} md={9}>
                        <p>
                          <span className={styles.companyVitalsDesc}>
                            {companyData.industry && companyData.industry.value}
                          </span>
                        </p>
                      </Col>
                    </Row>
                    <div className={styles.divider} />
                    <Row className={styles.box}>
                      <Col xs={12} sm={4} md={3}>
                        <p>
                          <span className={styles.companyVitalsTitle}>
                            Company Size
                          </span>
                        </p>
                      </Col>
                      <Col xs={12} sm={8} md={9}>
                        <p>
                          <span className={styles.companyVitalsDesc}>
                            {companyData.company_size &&
                              companyData.company_size.value}
                          </span>
                        </p>
                      </Col>
                    </Row>
                    <div className={styles.divider} />
                    <Row className={styles.box}>
                      <Col xs={12} sm={4} md={3}>
                        <p>
                          <span className={styles.companyVitalsTitle}>
                            Location
                          </span>
                        </p>
                      </Col>
                      <Col xs={12} sm={8} md={9}>
                        <p>
                          <span className={styles.companyVitalsDesc}>
                            {companyData.location}
                          </span>
                        </p>
                      </Col>
                    </Row>
                    <div className={styles.divider} />
                    <Row className={styles.box}>
                      <Col xs={12} sm={4} md={3}>
                        <p>
                          <span className={styles.companyVitalsTitle}>
                            Website or LinkedIn
                          </span>
                        </p>
                      </Col>
                      <Col xs={12} sm={8} md={9}>
                        <p>
                          {companyData.url && (
                            <a
                              href={
                                companyData.url.indexOf("http://") < 0 &&
                                companyData.url.indexOf("https://") < 0
                                  ? "//" + companyData.url
                                  : companyData.url
                              }
                              target="_blank"
                              className={styles.companyVitalsLink}
                            >
                              {companyData.url}
                            </a>
                          )}
                        </p>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </Row>
          </Grid>
        </section>
      </section>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/routes/employer/profile/components/Profile.js